import React, { PureComponent } from 'react';
import config from '../../config';
import { HTMLTrans } from '../Common/Translations';

export const icon = `${config.s3BucketUrl}/gift_card/sad-project-box.svg`;

class FailRedeemBody extends PureComponent {
  render() {
    const {
      closeCallback,
      errorMessage
    } = this.props;

    return (
      <div>
        <img src={icon}></img>
        <h2><HTMLTrans id="footer.giftcardcredit_failredeembody_title">Oh snap!</HTMLTrans></h2>
        <p><HTMLTrans id="footer.giftcardcredit_failredeembody_body">Your Gift Card Redeem was not successful. Please check if you  entered the correct code.</HTMLTrans></p>
        <p>{errorMessage}</p>
        <button
          className='btn btn-primary'
          onClick={closeCallback}
          ><HTMLTrans id="footer.giftcardcredit_failredeembody_ok_button">OK</HTMLTrans>
        </button>
      </div>
    );
  }
}

export default FailRedeemBody;



// WEBPACK FOOTER //
// ./src/GiftCardCredit/FailRedeemBody.js